const getOptionalArrayItem = <T>(condition: boolean, item: T): T[] => {
  return condition ? [item] : [];
};

export default getOptionalArrayItem;
